import * as styles from "../../../../styles/DefaultSetting";
import "react-confirm-alert/src/react-confirm-alert.css";
import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components/macro";
import Modal from "../../../../components/Modal";

import { confirmAlert } from "react-confirm-alert";
import { useFarms } from "hooks/farmInfo";

export const ModalCon = styled.div`
  position: absolute;
  top: -10%;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
`;

export const ModalWrapper = styled.div`
  background-color: white;
  border-radius: 30px;
  width: 390px;
  height: 281px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  div:last-child {
    margin-top: 50px;
    display: flex;
    position: relative;
    top: 25px;
  }
  p {
    background-color: #f7f7f7;
    width: 170px;
    text-align: center;
    margin: 0px 10px;
    padding: 10px 0px;
    color: #656565;
  }

  .right {
    background-color: #73972c;
    color: #ffffff;
  }
`;

export const ModalBack = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
`;

interface IBoxMoving {
	setModal: (modal: number) => void;
	alldata: any[];
	manageBox: any;
	setActionComplete: (actionComplete: boolean) => void;
}

const BoxMoving: React.FC<IBoxMoving> = ({ setModal, alldata, manageBox, setActionComplete }) => {

	const targetfarm = localStorage.getItem("targetfarm");
	const targetFarmInfo = JSON.parse(localStorage.getItem("targetfarmInfo") || '{}');
	// const { targetfarm } = useFarms();

	const [open, setOpen] = useState<boolean>(false);

	const [placeList, setPlaceList] = useState<any>(false); // [위치 리스트]
	const [selectMovePlace, setSelectMovePlace] = useState<any>(false); // [선택한 위치]
	const [currentBox, setCurrentBox] = useState<any>(false); // [현재 상자]

	// const [conid, setConid] = useState<any>(false);

	const [movePlace, setMovePlace] = useState<any>(false); // [이동할 장소]


	const moveBoxSubmit = (place: any) => {
		setOpen(true);
		setMovePlace(place);  // 이동할 장소
		setCurrentBox(manageBox); // 현재 선택된 BOX		
	};

	const getSpecificplace = () => {
		const getSpecificPlaceDepthType = (type: string) => {
			if (type === "FARM") {
				return 'CONTAINER';
			} else if (type === "CONTAINER") {
				return 'SECTION';
			} else if (type === "SECTION") {
				return 'BOX';
			}
		};

		const fetchData = async (sendData: any) => {
			try {
				const response = await axios.get(`/ifactory/api/place/specificplace?placeId=${sendData.id}`);
				// 이후 response를 사용하는 코드
				return response.data; // 결과 반환
			} catch (error: any) {
				confirmAlert({
					title: error?.data,
					buttons: [{ label: "Yes" }],
				});
			}
		};

		if (targetFarmInfo) {

			let sendData: any;
			if (selectMovePlace) {
				sendData = {
					type: getSpecificPlaceDepthType(selectMovePlace.type ?? ''),
					id: selectMovePlace.placeId ?? '',
				};
			} else {
				sendData = {
					type: getSpecificPlaceDepthType(selectMovePlace.type ?? ''),
					id: targetFarmInfo.placeId ?? '',
				};
			};

			// if(!sendData.type || !sendData.id) return console.log('type 또는 id가 없습니다.');

			fetchData(sendData)
				.then((data) => {
					// data가 배열이면 setPlaceList(data)로 설정, 아니라면 confirmAlert로 경고창 띄우기
					Array.isArray(data) ? setPlaceList(data) : confirmAlert({ title: data, buttons: [{ label: "Yes" }] });
				}).catch((error) => {
					confirmAlert({
						title: error.response.data,
						buttons: [{ label: "Yes" }],
					});
				});
		}
	}


	useEffect(() => {
		getSpecificplace();
	}, []);

	useEffect(() => {
		getSpecificplace();
	}, [selectMovePlace]);

	// 완료 시 초기화 하는 함수
	const moveClearReset = () => {
		// 초기화
		setModal(0);
		setMovePlace([]);  // 이동할 장소
		setCurrentBox([]); // 현재 선택된 BOX	
		setActionComplete(true); // 액션 완료
	};

	const movefunc = useCallback(
		async (type: string) => {
			if (targetfarm) {
				if (type === "YES") {

					await axios.put(`/ifactory/api/managebox/move/${manageBox.manageBoxId}`, {
						sectionId: movePlace.placeId, // 이동할 사육구역의 ID
						// manageBoxId: manageBox.manageBoxId,  // 선택한 상자의 ID
					}).then((res) => {
						confirmAlert({
							title: res.data,
							buttons: [
								{
									label: "Yes",
								},
							],
						});
						moveClearReset();
					}).catch((error) => {
						confirmAlert({
							title: error.response.data,
							buttons: [{ label: "Yes" }],
						});
						setModal(0);
					});
				} else {
					setModal(0);
				}
			} else {
				confirmAlert({
					title: "선택된 농장이 없습니다. 새로고침 후 다시 시도하세요.",
					buttons: [{ label: "Yes" }],
				});
			}

		}, [movePlace]);

	return (
		<styles.ModalContainer>
			<styles.BoxMovingModal>
				<p className="modal-close" onClick={() => { setModal(0) }}>
					<img src="./img/X.svg" alt="닫기" />
				</p>
				<div className="item-list">
					{placeList &&
						placeList.map((place: any, idx: number) => {
							return (
								<div key={idx}
									className="item"
									onClick={() => {
										// MoveBoxSubmit(place);
										if (place.type === "SECTION") {
											// 섹션일때 상자 이동
											moveBoxSubmit(place);
										} else {
											// 섹션이 아니면 해당 type 재조회
											setSelectMovePlace(place);
										}
									}}
								>
									<p>{place.name}</p>
								</div>
							);
						})}
				</div>
			</styles.BoxMovingModal>
			{open && (
				<Modal
					title={`상자를 정말 이동하시겠습니까?`}
					first={"예"}
					second={"아니오"}
					firstclick={() => movefunc("YES")}
					secondclick={() => movefunc("NO")}
				/>
			)}
		</styles.ModalContainer>
	);
};

// const BoxMoving = ({ setModal, alldata, manageBox }: any) => {	

// };

export default BoxMoving;
